import React from "react";
import { toast } from "sonner";
import { saveAnalysis } from "@/lib/vg2SavedAnalyses";
import { useAuth } from "@/lib/AuthContext";

// Shared "Salva nella dashboard" button for VALUTA (general + deep-dive).
// Owner-only: if the visitor is not an authenticated owner it points them
// to the owner access, carrying a return URL so they can finish afterwards.
export function SaveAnalysisButton({
  caseId, analysisId, scenarioKey = null, scenarioTitle = null, label = null,
  className = "", testid = "valuta-save-analysis",
}) {
  const { user } = useAuth();
  const [state, setState] = React.useState("idle"); // idle | saving | saved
  const isOwner = user && user.ruolo === "owner";

  const onSave = async () => {
    if (!caseId || !analysisId || state === "saving") return;
    if (!isOwner) {
      const ret = encodeURIComponent(window.location.pathname + window.location.search);
      toast.info("Accedi con il tuo account proprietario per salvare l'analisi.");
      window.location.href = `/proprietari?return=${ret}`;
      return;
    }
    setState("saving");
    try {
      const r = await saveAnalysis({ caseId, analysisId, scenarioKey, scenarioTitle, label });
      setState("saved");
      toast.success(r.already_saved
        ? "Analisi già presente nella tua dashboard."
        : "Analisi salvata nella tua dashboard.");
    } catch (e) {
      setState("idle");
      const code = e?.response?.status;
      if (code === 403) {
        toast.error(e?.response?.data?.detail
          || "Questa analisi non è collegata al tuo account.");
      } else if (code === 401) {
        const ret = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/proprietari?return=${ret}`;
      } else {
        toast.error("Impossibile salvare adesso. Riprova.");
      }
    }
  };

  return (
    <button
      type="button"
      onClick={onSave}
      disabled={state === "saving"}
      data-testid={testid}
      className={"inline-flex items-center gap-2 px-4 py-2 rounded-full border border-vg2-line text-sm font-semibold text-vg2-ink hover:bg-vg2-ink hover:text-white transition-colors disabled:opacity-60 " + className}
    >
      {state === "saved" ? "✓ Salvata nella dashboard"
        : state === "saving" ? "Salvataggio…"
        : "Salva nella dashboard"}
    </button>
  );
}

export default SaveAnalysisButton;
